import React, { useMemo } from 'react';
import { useParams, NavLink } from 'react-router-dom';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import validator from 'validator';
import PropTypes from 'prop-types';

const HtmlTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#FFF',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    border: `1px solid #dadde9`,
  },
}));

const TrafficLogTooltip = ({ eventCategory, attribute, value, ecoId, children }) => {
  const { cusID } = useParams();

  const title = useMemo(() => {
    let queryString = eventCategory ? `eq_EventCategory=${eventCategory}&` : '';
    let attr = attribute;
    if (attribute === 'Source' || attribute === 'Destination') {
      if (validator.isIP(value, 4)) attr = `${attribute}IP`;
      else attr = `${attribute}FQDN`;
    }
    queryString += `eq_${attr}=${value}`;
    return (
      <>
        <Typography>{value}</Typography>
        <Typography
          sx={{ fontSize: 14, textDecoration: 'underline' }}
          to={`/v1/customers/${cusID}/ecosystems/${ecoId}/logs/traffic?${queryString}`}
          component={NavLink}
        >
          Find host in the Traffic Logs
        </Typography>
      </>
    );
  }, [attribute, cusID, ecoId, eventCategory, value]);

  return <HtmlTooltip title={title}>{children}</HtmlTooltip>;
};

TrafficLogTooltip.propTypes = {
  attribute: PropTypes.string,
  value: PropTypes.string,
  eventCategory: PropTypes.string,
  ecoId: PropTypes.string,
  children: PropTypes.any,
};

export default TrafficLogTooltip;
